import classNames from 'classnames'
import React, { useContext } from 'react'

import useTeamMember from '../hooks/useTeamMember'
import { LocaleContext } from '../locale/i18n'
import { removeWhitespace } from '../logic/contentful'

import { Avatar } from './Avatar'
import { EmailLink } from './EmailLink'

import './ExpertContactCard.scss'

const ExpertContactCard = ({
  email,
  showContactInfo = false,
}: {
  email: string | null
  showContactInfo?: boolean
}) => {
  const { t } = useContext(LocaleContext)
  const teamMember = useTeamMember(email ?? '')

  const emailToShow =
    teamMember?.isActive && email ? email : 'info@measurlabs.com'

  return (
    <div
      className={classNames('expertContactCard', {
        'expertContactCard--inactive': !teamMember?.isActive,
      })}
    >
      <Avatar
        className="expertContactCard__img"
        variant="rounded"
        member={teamMember}
      />
      <div className="expertContactCard__contactDetails">
        <span className="expertContactCard__name">
          {teamMember?.profileUrl ? (
            <a href={teamMember?.profileUrl}>{teamMember?.name.full}</a>
          ) : (
            teamMember?.name.full
          )}
          {!teamMember?.isActive && ` (${t('common.inactiveEmployee')})`}
        </span>
        {showContactInfo && (
          <div className="expertContactCard__contactLinks">
            <EmailLink email={emailToShow} location="expertContactCard">
              {emailToShow}
            </EmailLink>
            {teamMember?.isActive && teamMember.customerFacingPhone && (
              <a
                href={`tel:${removeWhitespace(teamMember.customerFacingPhone)}`}
              >
                {teamMember.customerFacingPhone}
              </a>
            )}
          </div>
        )}
      </div>
    </div>
  )
}

export default ExpertContactCard
